import { render, staticRenderFns } from "./acknowledgement_model.vue?vue&type=template&id=3b99355a"
import script from "./acknowledgement_model.vue?vue&type=script&lang=js"
export * from "./acknowledgement_model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports